module.exports = __webpack_public_path__ + "media/images/pharma_admin/icons/gear-d54c7d6ecf651b5c752c0d7b36d56692.svg";